import React from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { Button } from "@mui/material";
import { responsiveFont, responsivePaddingVertical, responsivePaddingHorizontal, HorizontalPadding, responsiveImageSize } from '../../common/responsive.utils';

const Component03 = ({...props}) : React.ReactElement => {
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    const onClickBtn = () => {
        // 우주펫 파트너 카카오채널로 이동 
        window.open("http://pf.kakao.com/_yqagG/chat");
    }

    return (
        <>
            {isWeb ? (
                <> 
                    <div style={styles.divSty_Web}>
                        <span style={styles.titleTxt01_Web}>
                                기존 고객 데이터도 걱정 없이 옮기세요!
                        </span>
                            
                        <span style={styles.titleTxt02_Web}>
                                고객 정보를 파일로 전달해 주시면, 우주펫이 그대로 등록해 드려요.
                        </span>

                        <Button style={styles.buttonSty_Web} onClick={onClickBtn}>
                            <span style={styles.buttonTxt_Web}>정보 이관 문의하기 </span>
                        </Button>
                    </div>
                </>
                ) : (
                <>
                    <div style={styles.divSty_Mobile}>
                        <p style={styles.grdientTxt02_Mobile}>
                            기존 고객 데이터도
                            <br/>
                            걱정 없이 옮기세요!
                        </p>

                        <div style={{height : "2.5vh"}}/>
                            <p style={styles.titleTxt02_Mobile}>
                            고객 정보를 파일로 전달해 주시면,
                            <br/>
                            우주펫이 그대로 등록해 드려요.
                        </p>

                        <div style={{height : "3.5vh"}}/>

                        <Button style={styles.buttonSty_Mobile} onClick={onClickBtn}>
                            <span style={styles.buttonTxt_Mobile}>정보 이관 문의하기 </span>
                        </Button>   
                    </div>
                </>
            )}
        </>
    );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
    divSty_Web: {backgroundColor: "#8B4DFF", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingBottom: responsivePaddingVertical(50, 90), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24,88)},
    titleTxt01_Web: { fontFamily: "Pretendard", fontWeight: 800, fontSize: responsiveFont(22, 40), lineHeight: "140%", letterSpacing: "-3%", color: "#FFFFFF", paddingBottom:"15px",},
    titleTxt02_Web: { fontFamily: "Pretendard", fontWeight: 500, fontSize: responsiveFont(16, 26), lineHeight: "140%", letterSpacing: "-1%", color: "#FFFFFF", paddingBottom: "50px" },
    buttonSty_Web: { backgroundColor: "#FFFFFF", width: responsiveImageSize(208, 281), height: responsiveImageSize(46, 75), borderRadius: "9.75px", paddingBottom: responsivePaddingVertical(12, 19.5), paddingTop: responsivePaddingVertical(12, 19.5), gap:"16.25px" },
    buttonTxt_Web: { fontFamily: "Pretendard", fontWeight: 600, fontSize: responsiveFont(16, 26), lineHeight: "140%", letterSpacing: "-1%", color: "#8B4DFF" },

    divSty_Mobile: { width: "100%", minWidth: "320px", height: "94.6875vw", backgroundColor: "#9F6BFF", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" },
    grdientTxt02_Mobile: { color: "#FFFFFF", margin: 0, fontFamily: "Pretendard", fontSize: responsiveFont(22, 40), lineHeight: "140%", fontWeight: 800, letterSpacing: "-3%", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", textShadow: "none", },
    titleTxt02_Mobile: { padding: 0, margin: 0, fontSize: responsiveFont(16, 26), fontFamily: "Pretendard", fontWeight: 500, letterSpacing: "-1%", lineHeight: "140%", color: "#FFFFFF", whiteSpace: "nowrap", textShadow: "none", },
    buttonSty_Mobile: { backgroundColor: "#FFFFFF", width: responsiveImageSize(208, 450), height: responsiveImageSize(46, 99),  paddingBottom: responsivePaddingVertical(12, 19.5), paddingTop: responsivePaddingVertical(12, 19.5), paddingLeft: responsivePaddingHorizontal(27, 43.88), paddingRight: responsivePaddingHorizontal(27, 43.88), borderRadius: "6px" },
    buttonTxt_Mobile: { fontFamily: "Pretendard", fontWeight: 600, fontSize: responsiveFont(16, 26), lineHeight: "140%", letterSpacing: "-1%", color: "#8B4DFF" },
});

export default Component03;